/**
 * A-Roll SaaS English dictionary — the source of truth every other
 * locale is measured against. One fragment per surface; keys are
 * prefixed per surface so the merge can never collide.
 *
 * Writing rules (translators copy these files):
 *  - Interpolation slots are {name}; keep them verbatim in translations.
 *  - Plural pairs are explicit: `<key>_one` / `<key>_other`.
 *  - Doc comments describe context so translators are not guessing.
 */
import { wallet } from './wallet';
import { playback } from './playback';
import { shell } from './shell';
import { auth } from './auth';
import { projects } from './projects';
import { settings } from './settings';
import { share } from './share';
import { uploader } from './uploader';
import { shareModal } from './share-modal';
import { tray } from './tray';
import { room } from './room';

export const en = {
  ...wallet,
  ...playback,
  ...shell,
  ...auth,
  ...projects,
  ...settings,
  ...share,
  ...uploader,
  ...shareModal,
  ...tray,
  ...room,
} as const;

export type ArollKey = keyof typeof en;
